<template>
  <span></span>
</template>

<script>
export default {
  props: [
    'path'
  ],
  mounted () {
    window.location.pathname = this.path
  }
}
</script>